var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowpiMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.32 80.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M39.78 11.03c12.03,0 24.07,0 36.1,0l0 -9.8c0.34,-0.73 1.07,-1.23 1.93,-1.23 0.25,0 0.5,0.04 0.72,0.13l0 -0.06 11.32 8.31 10.97 8.05 0 0.22c0.87,0.27 1.5,1.07 1.5,2.03 0,0.66 -0.31,1.26 -0.78,1.65l-0.17 0.13c-0.17,0.11 -0.35,0.2 -0.54,0.25l0 0.14 -10.97 8.05 -11.52 8.46c-0.16,0.04 -0.33,0.06 -0.5,0.06 -0.87,0 -1.62,-0.52 -1.95,-1.27l0 -9.9c-8.85,0 -17.7,0 -26.55,0 -7.28,0 -17.47,-1.15 -23.45,3.44 -6.95,5.33 -8.39,9.63 -8.39,18.5 0,9.72 1.63,13.75 -3.88,16.28 -2.32,1.06 -4.02,1.19 -4.96,1.76 9.07,0 14.2,-1 20.25,-6.99 5.01,-4.96 2.36,-8.31 6.36,-11.68 2.66,-2.24 16.46,-3.46 11.91,10.49 -4.28,13.1 -18.33,21.76 -31.45,22.68 -18.09,1.27 -15.57,-3.15 -15.57,-19.1 0,-18.86 -2.45,-29.56 11.76,-42.36 7.5,-6.75 18.15,-8.23 27.86,-8.23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowpiMoveIcon);
export default __webpack_public_path__ + "static/media/flowpi-move-icon.30dff6447897c57d758a328982a5a6de.svg";
export { ForwardRef as ReactComponent };